















































































import { Component, Vue } from "vue-property-decorator";
import BlogCard from "./blog-card.vue";
import { Loader } from "../forms/parts";
import { Debounce } from "vue-debounce-decorator";

@Component({
    components: {
        BlogCard,
        Loader
    }
})
export default class BlogFilter extends Vue {
    loading: boolean = false;

    params: BlogParams = { per_page: 10, page: 1, blog_categories: [], paginate: 1 };

    articles: Article[] = [];

    meta: { total: number; pages: number } = { total: 0, pages: 0 };

    categories: number[] = [];

    category: number | null = null;

    page = 1;

    search: string = "";

    private mounted() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("search")) {
            this.search = urlParams.get("search") || "";
        }

        this.getCategories();
        this.getArticles();
    }

    private getArticles() {
        this.loading = true;
        this.params.page = this.page;

        // @ts-ignore
        axios
            .get("/api/articles", { params: { ...this.params, search: this.search } })
            .then((response: any) => {
                if (response.status === 200) {
                    this.articles = response.data.data.results;
                    this.meta = response.data.data.meta;
                } else {
                    this.articles = [];
                    this.meta = { total: 0, pages: 0 };
                }
            })
            .finally(() => (this.loading = false));
    }

    private changePage(p: number) {
        this.page = p;
        this.getArticles();
    }

    private getCategories() {
        this.loading = true;
        // @ts-ignore
        axios
            .get("/api/categories", { params: { taxonomy: "blog_categories" } })
            .then((response: any) => (this.categories = response.data.data))
            .finally(() => (this.loading = false));
    }

    private changeCategory(id: number | null) {
        if (id) {
            this.category = id;
            this.params.blog_categories = [id];
        } else {
            this.category = null;
            this.params.blog_categories = [];
        }
        this.getArticles();
    }

    private nextPage() {
        this.page--;
        this.getArticles();
    }
    private prevPage() {
        this.page++;
        this.getArticles();
    }

    private get paginatedPages(): number[] {
        const pages: number[] = [];

        if (this.page > 2) {
            pages.push(this.page - 2);
        }

        if (this.page > 1) {
            pages.push(this.page - 1);
        }

        pages.push(this.page);
        // @ts-ignore
        if (this.page < parseInt(this.meta.pages, 10) - 1) {
            pages.push(this.page + 1);
        }
        // @ts-ignore
        if (this.page < parseInt(this.meta.pages, 10) - 2) {
            pages.push(this.page + 2);
        }

        return pages;
    }

    @Debounce(500)
    private async handleSearch() {
        this.articles = [];

        this.loading = true;

        //@ts-ignore
        if (history.pushState) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?search=${this.search}`;
            window.history.pushState({ path: newurl }, "", newurl);
        }

        //@ts-ignore
        return axios
            .get("/api/articles", { params: { ...this.params, search: this.search } })
            .then((response: any) => {
                if (response.status === 200) {
                    this.articles = response.data.data.results;
                    this.meta = response.data.data.meta;
                } else {
                    this.articles = [];
                    this.meta = { total: 0, pages: 0 };
                }
            })
            .finally(() => (this.loading = false));
    }
}
